import { EmployerAgreementsService_employerAgreementsVersionsServiceGetEntity } from '@festina/life-general-types/life/hooks/EmployerAgreementsService_employerAgreementsVersionsServiceGetEntity'

export const useFetchEmployerAgreementVersionByEventId =
  EmployerAgreementsService_employerAgreementsVersionsServiceGetEntity.useSuspenseQuery
